
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sgc/desktop/products/[sku]",
      function () {
        return require("private-next-pages/sgc/desktop/products/[sku].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sgc/desktop/products/[sku]"])
      });
    }
  